function initialState() {
  return {
    accountFlags: null,
  }
}

let state = initialState()

export { initialState, state }
